import React from 'react';
import {
    Cell,
    Grid,
    H2,
} from '@saladbob/sassafras'

import Game from './Game';
import ByGame from './ByGame';

import style from './bracket.module.css';

import { Game as GameType } from '../../types'

type Props = {
    games: GameType[],
    tbGames: GameType[],
};

const rows = 23;

const Bracket6: React.FC<Props> = ({games, tbGames}) => {
    return (
        <div style={{ height: '100%', minWidth: 1124 }}>
            <Grid columns="repeat(5, 1fr)">
                {/* Round 1 */}
                <Grid rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '2 / 4' }}>
                        <Game game={games[0]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '6 / 8' }}>
                        <Game game={games[1]} topLabel bottomLabel />
                    </Cell>

                    {/* Toilet Bowl Heading */}

                    <Cell style={{ gridRow: '11 / 13' }} align="center" justify="flex-end" pe="md">
                        <H2
                            font="leader"
                            className={style.bracketHeading}
                            color="primary"
                        >
                            TOILET BOWL BRACKET
                        </H2>
                    </Cell>

                    {/* Losers */}

                    <Cell style={{ gridRow: '14 / 16' }} ps="md">
                        <H2 font="leader" className={style.bracketHeading} color="primary">LOSERS BRACKET</H2>
                    </Cell>

                    <Cell style={{ gridRow: '16 / 18' }}>
                        <Game game={games[4]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '20 / 22' }}>
                        <Game game={games[5]} topLabel bottomLabel />
                    </Cell>
                </Grid>
                {/* Round 2 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '1 / 3' }}>
                        <Game game={games[2]} topLabel  />
                    </Cell>
                    
                    <Cell style={{ gridRow: '7 / 9' }}>
                        <Game game={games[3]} bottomLabel />
                    </Cell>

                    {/* Toilet Bowl */}

                    <Cell style={{ gridRow: '11 / 13' }} bgColor="tertiary200">
                        <Game game={tbGames[0]} bottomLabel topLabel />
                    </Cell>

                    {/* Losers */}
                    <Cell style={{ gridRow: '17 / 21' }}>
                        <Game game={games[7]} />
                    </Cell>
                </Grid>
                {/* Round 3 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '2 / 8' }}>
                        <Game game={games[6]} />
                    </Cell>

                    {/* Toilet Bowl */}

                    <Cell style={{ gridRow: '11 / 12' }} bgColor="tertiary200" />

                    <Cell style={{ gridRow: '12 / 12' }} bgColor="tertiary200">
                        <ByGame tb color="black" />
                    </Cell>

                    {/* Losers */}

                    <Cell style={{ gridRow: '19 / 23' }}>
                        <Game
                            game={games[8]}
                            trophy='trophy'
                            trophyColor={['#A05822', 'white']}
                        />
                    </Cell>
                </Grid>
                {/* Round 4 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '5 / 21' }}>
                        <Game game={games[9]} />
                    </Cell>
                </Grid>

                {/* Round 5 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`} className={`${style.championship} ${style.printOnly}`}>
                    <Cell style={{ gridRow: '12 / 14' }} width="100px">
                        <ByGame
                            loserTrophy
                            trophy
                        />
                    </Cell>

                    <Cell style={{ gridRow: '14 / 16' }}>
                        <Game game={games[10]} />
                    </Cell>
                </Grid>
                {games[9].winner && games[9].team2.id === games[9].winner.id && (
                    <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`} className={`${style.championship} ${style.screenOnly}`}>
                        <Cell style={{ gridRow: '10 / 16' }} width="260px">
                            <Game game={games[10]} />
                        </Cell>
                    </Grid>
                )}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`} className={`${style.championship} ${style.screenOnly}`}>
                    <Cell style={{ gridRow: '12 / 14' }} width="100px">
                        <ByGame
                            loserTrophy
                            trophy
                        />
                    </Cell>
                </Grid>
            </Grid>
        </div>
    );
}

export default Bracket6;
